/**
 * 現在のiframeURLを親に伝える責務を担う
 * 親のURLをこれによって動的に変更する形
 */
import { useEffect } from 'react';

export const useEmitPushHistory = (pathname: string) => {
  useEffect(() => {
    window.parent.postMessage({ action: 'pushHistory', path: pathname }, '*');
  }, [pathname]);
};
